const SYM = { SEK: "kr", BDT: "৳" };

export const formatMoney = (amount, currency = "SEK") => {
  const v = Number(amount ?? 0);
  return `${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${SYM[currency] || currency}`;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const currencyOptions = [
  { value: "SEK", label: "SEK (kr)" },
  { value: "BDT", label: "BDT (৳)" },
];
